import { Transform } from 'engine/Transform';
import { V2, addV2 } from 'engine/lib/V2';
import { create } from 'engine/lib/create';
import { Desk } from '../end/Desk';
import { EndDoor } from '../end/EndDoor';
import { FranklinEnd } from '../end/FranklinEnd';
import { LadderBack, LadderFront } from '../end/Ladder';

interface EndMapProps {
  offset: V2,
  onExit: () => void,
  onTalk: () => void,
}

export const createEndMap = ({ offset, onExit, onTalk }: EndMapProps) => {
  const entities = {
    door: {
      entity: create(EndDoor, { onEnter: onExit }),
      config: { transform: new Transform() },
    },
    desk: {
      entity: create(Desk, {}),
      config: { transform: new Transform({ position: [310, 445] }) },
    },
    franklin: {
      entity: create(FranklinEnd, { onTalk }),
      config: { transform: new Transform({ position: [414, 455] }) },
    },

    ladderBack: {
      entity: create(LadderBack, {}),
      config: { transform: new Transform({ position: [599, 145] }) },
    },
    ladderFront: {
      entity: create(LadderFront, {}),
      config: { transform: new Transform({ position: [685, 190] }) },
    },
  };

  Object.values(entities).forEach(({ config }) => {
    addV2(config.transform.position, offset);
  });

  return entities;
};
